
export {fields as cedis} from './cedis';
export {fields as categorias} from './categorias';
export {fields as sub_categorias} from './sub_categorias';
export {fields as almacenistas} from './pcns';
export {fields as clientes} from './clientes';
export {fields as evaluadores} from './evaluadores';
export {fields as oficinas_de_ventas} from './oficinas_de_ventas';
export {fields as areas_de_ventas} from './areas_de_ventas';


